/**
 * @class
 */
import Base from 'netxcore@netx/core-category/models/category';

import customConfig from '../config';

export default class Category extends Base {
	/** @override */
	get clientAttrs() {
		return super.clientAttrs.concat(['truncated', 'crumbOverflow']);
	}

	/** @override */
	get parsers() {
		return {
			...super.parsers,
			/**
			 * Fetched category breadcrumbs
			 * calculates breadcrumb and overflow menu
			 * @override
			 * @param {array} data Return of the getCategoryBreadcrumbs call (label value objects)
			 */
			getCategoryBreadcrumbs(data, opts) {
				// TODO: should a category *model* be creating bread crumbs and even know about the DOM?
				// Answer: no
				/*
					measuring the width of crumbs by dipping them in the dom
				*/

				var maxWidth = 135,
					allCrumbs = _.toArray(data).reverse(),
					useCrumbs = [],
					overflowCrumbs = [],
					crumb,
					crumbWidth = 0,
					adj = 10;
				this.set('truncated', false);

				// THEM-1459 - breadcrumbs stop at the portal categroy setting
				var rootCrumb = _.findWhere(allCrumbs, {
						value: customConfig.categoryid.toString(),
					}),
					rootIdx = (rootCrumb && _.indexOf(allCrumbs, rootCrumb)) || 0;

				// top level category is not passed back with getCategoryBreadcrumbs
				// although it can be set as a portal category, shows up as "Folders"
				if (customConfig.categoryid > 1) {
					rootIdx++;
				}
				// cut off everything above the portal root category
				allCrumbs = allCrumbs.slice(rootIdx);

				while (allCrumbs.length) {
					crumb = allCrumbs.pop();

					// once you start down the overflow path, forever will it dominate your destiny, consume you it will
					if (overflowCrumbs.length > 0) {
						overflowCrumbs.push(crumb);
						continue;
					}

					// create element, hidden and possitioned off screen
					var $c = $('<div>', {class: 'invisible crumb-builder'}),
						// inject crumb html - if crumbs had their own templates we could grab that
						html =
							'<span class="separator">/</span><a href="#category/' +
							crumb.value +
							'" class="crumb primary-color-hover">' +
							crumb.label +
							'</a>';
					$c.append(html);
					// put into dom
					$('body').append($c);

					// if there's room use it, otherwise add to overflow dropdown
					// at least one || it fits
					if (
						useCrumbs.length == 0 ||
						crumbWidth + $c.width() + adj < maxWidth
					) {
						crumbWidth += $c.width() + adj;
						useCrumbs.unshift(crumb);
					} else {
						this.set('truncated', true);
						overflowCrumbs.push(crumb);
					}

					// cleanup
					$c.remove();
				}

				this.set({crumbOverflow: overflowCrumbs});

				// render is triggered on change:breadcrumb, need to render at times when useCrumbs do not change
				this.set({breadcrumb: [{something: 'nothing'}]}, {silent: true});
				this.set({breadcrumb: useCrumbs});
			},
		};
	}
}
